import { render, staticRenderFns } from "./AppPromoFooter.vue?vue&type=template&id=2071daaa&scoped=true"
import script from "./AppPromoFooter.vue?vue&type=script&lang=js"
export * from "./AppPromoFooter.vue?vue&type=script&lang=js"
import style0 from "./AppPromoFooter.vue?vue&type=style&index=0&id=2071daaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2071daaa",
  null
  
)

export default component.exports